"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.session.id': '会话ID',
};
